// src/store/modules/template.js
const state = {
    headerInfo: {},
    bottomInfo: {},
    headerStatusInfo: {},
    bottomHtmlText: '',
    headerHtmlText: '',
    headerStatusHtmlText: '',
    templateData: null,
    globalStyle: {},
}

const mutations = {
    // 设置主题
    SET_THEME_COLORS(state, colors) {
        state.colors = { ...state.globalStyle, ...colors }
        // 同时更新CSS变量
        Object.keys(colors).forEach(key => {
            document.documentElement.style.setProperty(`--theme-${key}`, colors[key])
        })
        // console.log(document.documentElement.style, 'stylllee')
    },

    // 设置浏览器标题和图标
    SET_BROWSER_TITLE_AND_ICON(state, globalStyleData) {
        // 设置浏览器标题
        if (globalStyleData.titleName) {
            document.title = globalStyleData.titleName;

            // 设置 <meta name="title">（可选）
            let metaTitle = document.querySelector('meta[name="title"]');
            if (!metaTitle) {
                metaTitle = document.createElement('meta');
                metaTitle.name = 'title';
                document.head.appendChild(metaTitle);
            }
            metaTitle.setAttribute('content', globalStyleData.titleName);
        }

        // 设置 Open Graph 标题（关键！用于微信/微博分享）
        let ogTitle = document.querySelector('meta[property="og:title"]');
        if (!ogTitle) {
            ogTitle = document.createElement('meta');
            ogTitle.setAttribute('property', 'og:title');
            document.head.appendChild(ogTitle);
        }
        ogTitle.setAttribute('content', globalStyleData.titleName || '默认标题');

        // 设置 Open Graph 描述（可选）
        let ogDesc = document.querySelector('meta[property="og:description"]');
        if (!ogDesc) {
            ogDesc = document.createElement('meta');
            ogDesc.setAttribute('property', 'og:description');
            document.head.appendChild(ogDesc);
        }
        ogDesc.setAttribute('content', globalStyleData.description || '物业协会官网');

        // 设置浏览器图标
        if (globalStyleData.titleIcon) {
            // 查找已存在的 favicon 链接
            let favicon = document.querySelector('link[rel="icon"]');
            if (favicon) {
                // 如果存在则更新 href
                favicon.href = globalStyleData.titleIcon;
            } else {
                // 如果不存在则创建新的 link 标签
                favicon = document.createElement('link');
                favicon.rel = 'icon';
                favicon.href = globalStyleData.titleIcon;
                document.head.appendChild(favicon);
            }
        }
    },
    SET_TEMPLATE_DATA(state, data) {
        state.templateData = data;
    },

    SET_HEADER_INFO(state, headerInfo) {
        state.headerInfo = headerInfo;
    },

    SET_BOTTOM_INFO(state, bottomInfo) {
        state.bottomInfo = bottomInfo;
    },

    SET_HEADER_STATUS_INFO(state, headerStatusInfo) {
        state.headerStatusInfo = headerStatusInfo;
    },

    SET_BOTTOM_HTML_TEXT(state, htmlText) {
        state.bottomHtmlText = htmlText;
    },

    SET_HEADER_HTML_TEXT(state, htmlText) {
        state.headerHtmlText = htmlText;
    },

    SET_HEADER_STATUS_HTML_TEXT(state, htmlText) {
        state.headerStatusHtmlText = htmlText;
    },

    CLEAR_TEMPLATE_DATA(state) {
        state.headerInfo = {};
        state.bottomInfo = {};
        state.headerStatusInfo = {};
        state.bottomHtmlText = '';
        state.headerHtmlText = '';
        state.headerStatusHtmlText = '';
        state.templateData = null;
    }
}

const actions = {
    setTemplateData({ commit }, templateData) {
        commit('SET_TEMPLATE_DATA', templateData);

        // 解析并设置各个模块信息
        if (templateData && templateData.resultData && templateData.resultData.moduleComponentList) {
            const moduleList = templateData.resultData.moduleComponentList;

            const headerInfo = moduleList.filter(item => item.moduleCode === 'headerBackground');
            const headerStatusInfo = moduleList.filter(item => item.moduleCode === 'headerInformation');
            const bottomInfo = moduleList.filter(item => item.moduleCode === 'bottom');
            const globalStyle = moduleList.filter(item => item.moduleCode === 'globalStyle');

            commit('SET_HEADER_INFO', headerInfo);
            commit('SET_HEADER_STATUS_INFO', headerStatusInfo);
            commit('SET_BOTTOM_INFO', bottomInfo);

            // 设置 HTML 内容
            if (bottomInfo && bottomInfo[0] && bottomInfo[0].componentList && bottomInfo[0].componentList[0]) {
                commit('SET_BOTTOM_HTML_TEXT', bottomInfo[0].componentList[0].styleData);
            }

            if (headerInfo && headerInfo[0] && headerInfo[0].componentList && headerInfo[0].componentList[0]) {
                commit('SET_HEADER_HTML_TEXT', headerInfo[0].componentList[0].styleData);
            }

            if (headerStatusInfo && headerStatusInfo[0] && headerStatusInfo[0].componentList && headerStatusInfo[0].componentList[0]) {
                commit('SET_HEADER_STATUS_HTML_TEXT', headerStatusInfo[0].componentList[0].styleData);
            }

            if (globalStyle[0]?.moduleStyleData) {
                commit('SET_THEME_COLORS', JSON.parse(globalStyle[0].moduleStyleData));
                commit('SET_BROWSER_TITLE_AND_ICON', JSON.parse(globalStyle[0].moduleStyleData));
            }
        }
    },

    clearTemplateData({ commit }) {
        commit('CLEAR_TEMPLATE_DATA');
    }
}

const getters = {
    templateData: state => state.templateData,
    headerInfo: state => state.headerInfo,
    bottomInfo: state => state.bottomInfo,
    headerStatusInfo: state => state.headerStatusInfo,
    bottomHtmlText: state => state.bottomHtmlText,
    headerHtmlText: state => state.headerHtmlText,
    headerStatusHtmlText: state => state.headerStatusHtmlText,

    // 获取特定模块的信息
    getModuleByCode: (state) => (moduleCode) => {
        if (!state.templateData || !state.templateData.resultData) return null;

        return state.templateData.resultData.moduleComponentList.find(
            item => item.moduleCode === moduleCode
        );
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
